import z from 'zod';

export const QC_STATUS = ['APPROVED', 'REJECTED'] as const;

export const post = {
  body: z.array(
    z.object({
      receipt_id: z.coerce.number().min(1, { error: 'Receipt id is required' }),
      qc_status: z
        .string()
        .nonempty({ error: 'QC status is required' })
        .refine(
          (val) => QC_STATUS.includes(val as (typeof QC_STATUS)[number]),
          {
            error: 'Select a valid status',
          },
        ),
      quantity: z.coerce.number().min(1, { error: 'Quantity is required' }),
      qc_notes: z.string().optional(),
    }),
  ),
  response: z.array(
    z.object({
      receipt_id: z.number(),
      qc_status: z.string(),
      quantity: z.number(),
      qc_notes: z.string(),
    }),
  ),
  params: z.never(),
  query: z.never(),
};

const postSchema = z.object(post);
export type Post = z.infer<typeof postSchema>;

const get = {
  body: z.never(),
  response: z.array(
    z.object({
      id: z.number(),
      part_number: z.string(),
      available_qty: z.number(),
      on_hold_qty: z.number(),
    }),
  ),
  params: z.object({
    project_id: z.coerce.number(),
  }),
  query: z.never(),
};

const getSchema = z.object(get);
export type Get = z.infer<typeof getSchema>;

export const patch = {
  body: z.union([
    z.object({
      on_hold_qty: z.coerce
        .number({ error: 'On hold quantity is required.' })
        .nonnegative({ error: 'On hold quantity cannot be negative.' }),
      delta: z.never().optional(),
    }),
    z.object({
      on_hold_qty: z.never().optional(),
      delta: z.coerce
        .number({ error: 'Delta quantity is required.' })
        .refine((val) => val !== 0, {
          message: 'Delta cannot be zero.',
        }),
    }),
  ]),
  response: z.never(),
  params: z.object({
    inventory_id: z.coerce.number(),
  }),
  query: z.never(),
};
const patchSchema = z.object(patch);
export type Patch = z.infer<typeof patchSchema>;
